// extracted by css-extract-rspack-plugin
module.exports =  {"root":"b6ec949e94","item":"fdbc3f30a1"};